import { computed, ComputedRef } from 'vue';
import { useStore } from 'vuex';

import { placeholderContactImg, placeholderPropertyImg } from '@/settings';

interface IUsePlaceholders {
  contactPlaceholder: ComputedRef<string>;
  propertyPlaceholder: ComputedRef<string>;
}

/**
 * Contact / property placeholder images: the account's own image when set,
 * otherwise the app default.
 */
export const usePlaceholders = (): IUsePlaceholders => {
  const store = useStore();

  const contactPlaceholder = computed<string>(() => store.state.accountPreferences?.contact_placeholder || placeholderContactImg);
  const propertyPlaceholder = computed<string>(() => store.state.accountPreferences?.property_placeholder || placeholderPropertyImg);

  return { contactPlaceholder, propertyPlaceholder };
};
